export const getFullWidth = (el, withPadding) => {
    const style = el.currentStyle || window.getComputedStyle(el);
    const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    const border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

    return el.offsetWidth + margin + (withPadding ? 1 : -1) * padding + border;
};
